module.exports = __webpack_public_path__ + "media/act.eae28e71.mp4";